import React from 'react';
import SEOHead from '../components/SEOHead';
import { getCurrentDate } from '../utils/dateUtils';
import './Terms.css';

const Terms = () => {
  return (
    <>
      <SEOHead 
        title="Terms & Conditions - YT DOWN | Video Downloader Service Terms"
        description="Read YT DOWN's terms and conditions. Understand the rules for using our free YouTube and TikTok video downloader service. User responsibilities, copyright compliance, and service limitations."
        keywords="terms and conditions, yt down terms, youtube downloader terms, tiktok downloader terms, service terms, user agreement, legal terms"
        url="https://digimac.pro/terms"
      />
      <section id="terms" className="terms-section">
      <div className="terms-container">
        <div className="terms-hero">
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-subtitle">Please Read These Terms Carefully Before Using Our Service</p>
          <p className="last-updated">Last Updated: {getCurrentDate()}</p>
        </div>

        <div className="terms-content">
          <TermsContent />
        </div>
      </div>
    </section>
    </>
  );
};

const TermsContent = () => (
  <>
    <div className="terms-block">
      <h2>1. Introduction</h2>
      <p>Welcome to YT DOWN, a free online YouTube and TikTok video downloader. By using our service, you agree to these Terms.</p>
    </div>

    <div className="terms-block">
      <h2>2. Use of Service</h2>
      <p><strong>Personal Use Only:</strong> Download videos for personal, non-commercial use.</p>
      <p><strong>No Storage:</strong> We don't host or store videos.</p>
      <p><strong>Public Content:</strong> Only publicly available videos.</p>
    </div>

    <div className="terms-block highlight-block">
      <h2>3. User Responsibilities</h2>
      <p><strong>You must comply with copyright laws.</strong></p>
      <p><strong>You're responsible for downloaded content use.</strong></p>
      <p><strong>We're not liable for misuse.</strong></p>
    </div>

    <div className="terms-block">
      <h2>4. Prohibited Activities</h2>
      <ul>
        <li>No scraping or automated access</li>
        <li>No hacking or security breaches</li>
        <li>No reverse engineering</li>
        <li>No unlawful purposes</li>
        <li>No service disruption</li>
      </ul>
    </div>

    <div className="terms-block">
      <h2>5. Intellectual Property</h2>
      <p><strong>Our Platform:</strong> Website design and content belong to YT DOWN.</p>
      <p><strong>Videos:</strong> We don't claim ownership of downloaded videos.</p>
    </div>

    <div className="terms-block">
      <h2>6. Third-Party Content</h2>
      <p><strong>Not Affiliated:</strong> We're not affiliated with YouTube, TikTok, Google, or ByteDance.</p>
      <p><strong>Content Ownership:</strong> Videos belong to their creators.</p>
    </div>

    <div className="terms-block">
      <h2>7. Service Availability</h2>
      <p>Service may be updated, changed, or interrupted at any time.</p>
      <p>No guaranteed uptime or uninterrupted availability.</p>
    </div>

    <div className="terms-block highlight-block">
      <h2>8. Limitation of Liability</h2>
      <p><strong>Service provided "AS IS" without warranties.</strong></p>
      <p><strong>Not liable for damages, errors, or failed downloads.</strong></p>
      <p><strong>You use the service at your own risk.</strong></p>
    </div>

    <div className="terms-block">
      <h2>9. Changes to Terms</h2>
      <p>Terms may be updated at any time.</p>
      <p>Continued use means acceptance of updated terms.</p>
    </div>

    <div className="terms-block">
      <h2>10. Governing Law</h2>
      <p>These Terms follow standard international web service guidelines.</p>
    </div>

    <div className="terms-block contact-block">
      <h2>11. Contact Us</h2>
      <p>Questions about these Terms?</p>
      <p><strong>Email:</strong> ramsis.nagham@outlook.com</p>
    </div>

    <div className="terms-cta">
      <h2>By Using Our Service, You Agree to These Terms</h2>
      <a href="/" className="cta-button">I Agree - Start Downloading</a>
    </div>
  </>
);

export default Terms;
